var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemLineElement_1;
import { CustomElement, Watch, PropertyConverters, P, Utils } from '@pacem/pacem-core';
import { ShapeElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
import { Shape } from './drawing';
//namespace Pacem.Components.Drawing {
let PacemLineElement = PacemLineElement_1 = class PacemLineElement extends ShapeElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'from':
                case 'to':
                    this.recomputeShape();
                    break;
            }
        }
    }
    getShapeGeometry() {
        const from = this.from, to = this.to;
        if (Utils.isNull(from) || Utils.isNull(to)) {
            return Shape.empty();
        }
        const x0 = from.x, y0 = from.y, x1 = to.x, y1 = to.y;
        const boundingRect = { x: Math.min(x0, x1), y: Math.min(y0, y1), width: Math.abs(x0 - x1), height: Math.abs(y0 - y1) };
        return { pathData: this.getPathData(), vertices: [from, to], boundingRect };
    }
    getPathData() {
        const from = this.from, to = this.to;
        if (!Utils.isNull(from) && !Utils.isNull(to)) {
            return PacemLineElement_1.getPathData(from, to);
        }
        return null;
    }
    static getPathData(from = { x: NaN, y: NaN }, to = { x: NaN, y: NaN }) {
        const x0 = from.x, y0 = from.y, x1 = to.x, y1 = to.y;
        return `M ${x0} ${y0} L ${x1} ${y1}`;
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemLineElement.prototype, "from", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemLineElement.prototype, "to", void 0);
PacemLineElement = PacemLineElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-line' })
], PacemLineElement);
export { PacemLineElement };
